<template>
  <div>
    <!-- 头部信息 -->
    <div class="clear"></div>
    <div class="mapbox mt_h">

      <div class="bj_white2 home">
        <div class="country clearfix">
          <img class="fl" :src="addgjflagsrc()" />
          <h2 class="fl">{{ countryname }}</h2>
          <h6 class="fr">资料来源：世界银行</h6>
        </div>

        <div class>
          <div class="col-lg-6 w33 W34 characteristics">
            <ul>
              <li>
                <span>国家分组：</span>
                {{ countryrange }}
              </li>
              <li>
                <span>收入水平：</span>
                {{ countryincome }}
              </li>
            </ul>
          </div>
          <div class="col-lg-6 w33">
            <h2 class="fl">{{ this.interfaceGetYearData[0].name }}营商环境排名:</h2>
            <div class="review fl">
              <singleBar :nameList="nameListN" :rankList="rankListN" :totalList="totalListN" />
            </div>
          </div>
          <div class="col-lg-6 w33">
            <h2 class="fl">{{ this.interfaceGetYearData[0].name }}营商环境得分:</h2>
            <div class="review fl">
              <singleBar :nameList="nameListN" :scoreList="scoreListN" />
            </div>
          </div>
          <div class="clear"></div>
        </div>
      </div>
    </div>
    <!-- 柱状图 -->
    <div class="home p5 clearfix">

      <div class="w33 fl">

        <div class="box1 bj_white2">
          <div class="card_title">
            <h1>最近5年营商环境指数得分</h1>
          </div>
          <!-- 图一：可多选 -->
          <div class="box1 bj_white2">
            <div class="C1-style" :class="chart1Selected.includes(1) ? 'NC-active' : ''" @click="handleClickC1(1)">支柱一
            </div>
            <div class="C1-style" :class="chart1Selected.includes(2) ? 'NC-active' : ''" @click="handleClickC1(2)">支柱二
            </div>
            <div class="C1-style" :class="chart1Selected.includes(3) ? 'NC-active' : ''" @click="handleClickC1(3)">支柱三
            </div>
          </div>
          <!-- 修复：统一使用 c-chart 短横线命名 -->
          <c-chart id="chart1" ref="chart1" :option="option1" :style="{ margin: '0 auto', height: '346px' }"></c-chart>
        </div>

      </div>

      <div class="w33 fl">

        <div class="box1 bj_white2">
          <div class="card_title">
            <h1>营商环境指标分项排名({{ this.interfaceGetYearData[0].name }})</h1>
          </div>

          <c-chart v-show="chart2_chart" id="chart2" ref="chart2" :option="option2"
            :style="{ margin: '0 auto', height: '402px' }"></c-chart>
          <img v-show="chart2_img" src="../../../assets/imgs/cgitchartdefault.jpg"
            style="margin:0 auto; height:402px;width: 100%;" />
        </div>
      </div>
      <div class="w33 fl">
        <div class="box1 bj_white2">
          <div class="card_title">
            <h1>营商环境指标分项得分({{ this.interfaceGetYearData[0].name }})</h1>
          </div>
          <PillarChart :chartData="chartData3" :carousel="false" labelMode="score" height="500" :showFlag="false" />
        </div>
      </div>
    </div>
    <!-- 可选指标柱状图、雷达图 -->
    <div class="home p5">
      <div class="w50 fl">
        <div class="box1 bj_white2">
          <div class="card_title">
            <h1>{{ chart4title }}营商环境指数得分历年变化</h1>
          </div>
          <!-- 图四：可多选，总分按钮条件显示 -->
          <div class="box1 bj_white2">
            <!-- 修复：添加 v-if 确保 C4ChildrenList 有数据 -->
            <div class="C1-style" :class="chart4Selected.includes(C4ChildrenList.IndicatorId) ? 'NC-active' : ''"
              @click="handleClickC4(C4ChildrenList.IndicatorId)"
              v-if="C4ChildrenList && C4ChildrenList.IndicatorId && C4ChildrenList.IndicatorId != 44">总分
            </div>
            <div class="C1-style" v-for="item, index in (C4ChildrenList.children || [])"
              :class="chart4Selected.includes(item.IndicatorId) ? 'NC-active' : ''"
              @click="handleClickC4(item.IndicatorId)">
              {{ item.Name }}
            </div>
          </div>
          <div class>
            <div class="fl menu_box" style="height: 438px;width:25%">
              <ul class="menu_box_ul">
                <li v-for="(item, index) in newDataList" :key="item.IndicatorId">
                  <a @click="handleClickList(index, item)"
                    :class="[`icon${index + 1}`, { [`icon${index + 1}_on`]: activeMenuId === item.IndicatorId }]"
                    :title="item.Name">
                    <span :class="{ [`icon${index + 1}_on_span`]: activeMenuId === item.IndicatorId }">
                      {{ item.Name }}
                    </span>
                  </a>
                </li>
              </ul>
            </div>
            <div class="fr txbox">
              <div class="fr" style="margin-right: 6%">
                <el-date-picker v-model="chart4date1" type="year" value-format="yyyy" placeholder="开始日期"
                  prefix-icon="elinputiconimg" class="el-input__inner_date" :default-value="timeDefaultShow"
                  :picker-options="pickerOptions_start" @change="datepicker1change"></el-date-picker>
                <el-date-picker v-model="chart4date2" type="year" value-format="yyyy" placeholder="结束日期"
                  prefix-icon="elinputiconimg" class="el-input__inner_date" :picker-options="pickerOptions_end"
                  @change="datepicker2change"></el-date-picker>
              </div>
              <!-- 修复：统一使用 c-chart 短横线命名 -->
              <c-chart id="chart4" ref="chart4" :option="option4" :style="{ height: '378px', margin: '50px 0 0 0 ' }">
              </c-chart>
            </div>
            <div class="clear"></div>
          </div>
        </div>
      </div>

      <div class="w50 fl">
        <div class="box1 bj_white2" style="height: 540px;">
          <div class="card_title">
            <h1>{{ chart5title }}营商环境分项指标对比</h1>
          </div>
          <div class="fl chart5elselect">
            <!-- 当前国家固定显示（不可移除） -->
            <div class="current-country-tag">
              <span class="tag-label">当前:</span>
              <span class="tag-name">{{ countryname }}</span>
            </div>
            <!-- 对比国家多选框（最多5个） -->
            <el-select v-model="chart5countrymodel" multiple filterable placeholder=" " @change="selectchart5countrys"
              :multiple-limit="4" class="compare-select">
              <el-option v-for="item in chart5country" v-if="item.name != countryname" :key="item.value"
                :label="item.name" :value="item.value" :disabled="item.value === countryid">
              </el-option>
            </el-select>
          </div>
          <div>
            <!-- 修复：统一使用 c-chart 短横线命名 -->
            <c-chart id="chart5" ref="chart5" :option="option5" :style="{ height: '380px', margin: '50px 0 0 0 ' }">
            </c-chart>
          </div>
        </div>
      </div>
      <div class="clear"></div>
    </div>
  </div>
</template>

<script>
import echarts from "echarts";
import cChart from "../cgit_chart.vue";
import { api } from "@/require/api";
import PillarChart from "./components/PillarChart.vue";
import singleBar from "./components/singleBar.vue";
export default {
  data() {
    return {
      indicatorid: 1,
      countryid: "",
      countryname: "",
      countryrange: "",
      newyear: "",
      countryincome: "",
      CurrentRant: "",
      LowestRank: "",
      Rankpercent: "",
      Rankpercentpart: "",
      Scorepercent: "",
      Scorepercentpart: "",
      MinScore: "",
      Score: "",
      MaxScore: "",
      startTid: "",
      endTid: "",
      docs: [],
      docs1: [],
      docs2: [],
      countryBId: [],

      chart4title: "",
      timeDefaultShow: "",
      pickerOptions_start: {
        disabledDate: time => {
          if (!this.interfaceGetYearData || this.interfaceGetYearData.length === 0) {
            return true;
          }
          const yearList = this.interfaceGetYearData.map(item => {
            const val = typeof item === 'object' ? item.value : item;
            return parseInt(val);
          });
          const year = time.getFullYear();
          return !yearList.includes(year);
        }
      },
      pickerOptions_end: {
        disabledDate: time => {
          if (!this.interfaceGetYearData || this.interfaceGetYearData.length === 0) {
            return true;
          }
          const yearList = this.interfaceGetYearData.map(item => {
            const val = typeof item === 'object' ? item.value : item;
            return parseInt(val);
          });
          const year = time.getFullYear();
          const notInList = !yearList.includes(year);
          if (this.chart4date1) {
            return notInList || year <= parseInt(this.chart4date1);
          }
          return notInList;
        }
      },
      chart4date1: "",
      chart4date2: "",
      flag: 0,

      chart5title: "",
      chart5country: [],
      chart5countrymodel: [],

      option1: {
        toolbox: {
          feature: {
            saveAsImage: {
              pixelRatio: 2
            }
          }
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
            label: {
              show: true,
              backgroundColor: "#1D91CE"
            }
          }
        },
        legend: {
          data: ["支柱一", "支柱二", "支柱三"],
          x: "left",
          padding: [10, 0, 10, 40]
        },
        xAxis: {
          data: [],
          axisTick: {
            show: false
          }
        },
        yAxis: {
          type: "value",
          name: "得分",
          splitLine: { show: false }
        },
        series: []
      },
      option2: {
        toolbox: {
          feature: {
            saveAsImage: {
              pixelRatio: 2
            }
          }
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow"
          }
        },
        grid: [
          {
            height: "85%",
            left: "20%",
            bottom: "11%"
          },
          {
            height: "85%",
            left: "20%",
            bottom: "11%"
          }
        ],
        xAxis: [
          {
            splitLine: {
              show: false
            }
          },
          {
            gridIndex: 1
          }
        ],
        yAxis: [
          {
            data: [],
            axisLabel: {
              show: true,
              interval: 0,
              rotate: 0
            }
          },
          {
            gridIndex: 1
          }
        ],
        series: [
          {
            name: "",
            type: "bar",
            label: {
              normal: {
                show: true,
                position: "right",
                textStyle: {
                  color: "#000",
                  fontSize: "12"
                }
              }
            },
            itemStyle: {
              normal: {
                color: "#36A5ED"
              }
            },
            barWidth: 25,
            data: []
          }
        ]
      },
      option3: {
        toolbox: {
          feature: {
            saveAsImage: {
              pixelRatio: 2
            }
          }
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
            type: "none"
          }
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true
        },
        xAxis: [
          {
            type: "category",
            data: [],
            axisTick: {
              alignWithLabel: true
            },
            axisLabel: {
              interval: 0,
              rotate: 40
            }
          }
        ],
        yAxis: [
          {
            type: "value"
          }
        ],
        series: [
          {
            itemStyle: {
              normal: {
                color: "#36A5ED"
              }
            },
            name: "",
            type: "bar",
            barWidth: "65%",
            data: []
          }
        ]
      },
      option4: {
        toolbox: {
          feature: {
            saveAsImage: {
              pixelRatio: 2
            }
          }
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
            label: {
              show: true,
              backgroundColor: "#1D91CE"
            }
          }
        },
        legend: {
          data: [],
          x: "left",
          padding: [10, 0, 10, 40]
        },
        xAxis: {
          data: [],
          axisTick: {
            show: false
          },
          axisLabel: {
            rotate: 40
          }
        },
        yAxis: {
          type: "value",
          name: "得分",
          splitLine: { show: false }
        },
        series: []
      },
      option5: {
        color: ["#F07226", "#14A8D6", "#52c41a", "#722ed1", "#eb2f96", "#faad14"],
        toolbox: {
          feature: {
            saveAsImage: {
              pixelRatio: 2
            }
          }
        },
        tooltip: {

        },
        legend: {
          x: "left",
          y: "bottom",
          orient: "vertical",
          icon: "roundRect",
          padding: [0, 0, 30, 40],
          data: [],

        },
        radar: {
          axisLabel: {
            show: false,
            showMaxLabel: true,
            showMinLabel: true,
            textStyle: { fontSize: 10, color: "#999999" }
          },
          axisTick: {
            show: false,
            inside: true,
            length: 50,
          },
          name: {
            textStyle: {
              color: "#fff",
              backgroundColor: "#f58866",
              borderRadius: 3,
              padding: [3, 5]
            }
          },
          indicator: [
            { name: "企业准入", max: 100 },
            { name: "经营场所", max: 100, axisLabel: { show: false } },
            { name: "公用服务设施", max: 200, axisLabel: { show: false } },
            { name: "劳动力", max: 200, axisLabel: { show: false } },
            { name: "金融服务", max: 200, axisLabel: { show: false } },
            { name: "国际贸易", max: 200, axisLabel: { show: false } },
            { name: "纳税", max: 200, axisLabel: { show: false } },
            { name: "争端解决", max: 200, axisLabel: { show: false } },
            { name: "市场竞争", max: 200, axisLabel: { show: false } },
            { name: "企业破产", max: 200, axisLabel: { show: false } },
          ]
        },
        polar: {},
        angleAxis: {
          show: false,
          axisTick: {
            show: false,
            inside: true,
          },
        },
        radiusAxis: {
          min: 0,
          max: 100,
          interval: 20,
          axisTick: {
            show: false,
            inside: true,
          },
          splitLine: {
            show: false
          }
        },
        series: [
          {
            name: "",
            type: "radar",
            symbolSize: 4,
            lineStyle: {
              normal: {
                color: "#14A8D6",
                width: 2
              }
            },
            data: []
          }
        ]
      },
      chart2_chart: true,
      chart2_img: false,
      interfaceGetYearData: [],
      chartData3: [],
      rankListN: [],
      scoreListN: [],
      nameListN: [],
      newDataList: [],
      // 修复：初始化为空对象而非空数组，避免访问属性报错
      C4ChildrenList: {},
      totalListN: [],
      activeMenuId: null,
      // 图一多选选中项
      chart1Selected: [1, 2, 3],
      // 图四多选选中项
      chart4Selected: [],
      // 图一缓存数据
      chart1MultiData: {
        pillar1: null,
        pillar2: null,
        pillar3: null
      },
      // 图四缓存数据
      chart4MultiData: {},
      // 图四当前可选的indicatorId列表
      chart4AvailableIds: []
    };
  },
  created() {
    this.getNavData()
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      this.countryid = this.$route.query.countryid;
      this.getTimeAndCountryData()
      this.loadTLPHeaderInfo();
      this.loadchart5country();

      // 重置图一多选
      this.chart1Selected = [1, 2, 3];
      this.chart1MultiData = { pillar1: null, pillar2: null, pillar3: null };

      this.icon1();
      this.addgjflagsrc();

      // 首次加载图一
      setTimeout(() => {
        this.loadchart1Multi();
      }, 1000)
      setTimeout(() => {
        this.loadchart4Multi();
      }, 1000)
      this.loadchart2();
      this.loadchart3();

      setTimeout(() => {
        this.loadchart5();
      }, 1000)

      setTimeout(() => {
        this.loaddocument();
      }, 1000);
    },
    //头部排名得分信息
    async loadTLPHeaderInfo() {
      const { code, data } = await api.get(
        "/doingBusiness2026Controller/getTLPHeaderInfo",
        {
          countryId: this.countryid
        }
      );
      if (data) {
        this.chart4title = data.CountryName;
        this.countryname = data.CountryName;
        this.countryrange = data.RegionName;
        this.countryincome = data.IncomeLevel;
        this.nameListN = data.nameList;
        this.scoreListN = data.scoreList;
        this.rankListN = data.rankList;
        this.totalListN = data.maxRankList
      }
    },
    //国旗图标
    addgjflagsrc() {
      try {
        let gjimgs = require("../../../assets/imgs/flag/" +
          this.countryname +
          ".png");
        return gjimgs;
      } catch (err) {
        let gjerrorimg = require("../../../assets/imgs/flag/default.png");
        return gjerrorimg;
      }
    },
    async getNavData() {
      const data = await api.get("/doingBusiness2026Controller/getIndicatorTree")

      if (data.data.list.length > 0) {
        this.newDataList = data.data.list
        const firstItem = this.newDataList[0]
        this.activeMenuId = firstItem.IndicatorId
        this.handleClickList(0, firstItem)
      }
    },
    handleClickList(index, item) {
      this.activeMenuId = item.IndicatorId

      const methodName = `icon${index + 1}`;
      if (this[methodName]) {
        this[methodName]();
      } else {
        console.warn(`Method ${methodName} not found!`);
      }

      this.C4ChildrenList = item

      // 计算图四当前可选的indicatorId列表
      this.chart4AvailableIds = []
      // 总分按钮：非三支柱时显示
      if (item.IndicatorId != 44) {
        this.chart4AvailableIds.push(item.IndicatorId)
      }
      // 子项
      if (item.children && item.children.length > 0) {
        item.children.forEach(child => {
          this.chart4AvailableIds.push(child.IndicatorId)
        })
      }

      // 默认全选当前所有可选项
      this.chart4Selected = [...this.chart4AvailableIds]
      this.chart4MultiData = {}

      // 修复：确保时间已初始化再加载图四
      if (this.chart4date1 && this.chart4date2) {
        this.loadchart4Multi();
      } else {
        // 等待时间数据加载完成后再加载
        this.$nextTick(() => {
          setTimeout(() => {
            if (this.chart4date1 && this.chart4date2) {
              this.loadchart4Multi();
            }
          }, 500);
        });
      }
    },
    // 获取时间
    async getTimeAndCountryData() {
      const { code, data } = await api.get('/doingBusiness2026Controller/getTimesAndCountrys');
      if (code === 0) {
        this.interfaceGetYearData = data.times;

        if (this.interfaceGetYearData && this.interfaceGetYearData.length > 0) {
          const startYear = this.interfaceGetYearData[this.interfaceGetYearData.length - 1];
          const endYear = this.interfaceGetYearData[0];

          this.chart4date1 = typeof startYear === 'object' ? startYear.value : startYear;
          this.chart4date2 = typeof endYear === 'object' ? endYear.value : endYear;
        }
      }
    },
    // 图一：点击切换选中状态（可多选）
    handleClickC1(id) {
      const index = this.chart1Selected.indexOf(id);
      if (index > -1) {
        // 至少保留一个选中
        if (this.chart1Selected.length > 1) {
          this.chart1Selected.splice(index, 1);
        }
      } else {
        this.chart1Selected.push(id);
      }
      this.loadchart1Multi();
    },
    // 图一：加载多选数据（不显示总数）
    async loadchart1Multi() {
      try {
        // 只加载选中的支柱
        const requests = [];
        const pillarMap = { 1: 'pillar1', 2: 'pillar2', 3: 'pillar3' };
        // 固定颜色配置
        const colors = { 1: '#8DC6F5', 2: '#52c41a', 3: '#F07226' };
        const names = { 1: '支柱一', 2: '支柱二', 3: '支柱三' };
        // 固定顺序：1, 2, 3
        const fixedOrder = [1, 2, 3];

        this.chart1Selected.forEach(id => {
          if (!this.chart1MultiData[pillarMap[id]]) {
            requests.push(
              api.get("/doingBusiness2026Controller/getRecentFiveInfo", {
                countryId: this.countryid,
                indicatorId: id
              }).then(res => {
                this.chart1MultiData[pillarMap[id]] = res.code === 0 ? res.data : null;
              })
            );
          }
        });

        if (requests.length > 0) {
          await Promise.all(requests);
        }

        // 以第一个有数据的为基准获取x轴
        let baseData = null;
        for (const id of fixedOrder) {
          const data = this.chart1MultiData[pillarMap[id]];
          if (data) {
            baseData = data;
            break;
          }
        }
        const xAxisData = baseData ? (baseData.time || []) : [];

        // 构建series —— 按固定顺序 1,2,3，只显示选中的
        const series = [];
        const legendData = [];

        // 按固定顺序遍历，确保位置和颜色固定
        fixedOrder.forEach(id => {
          // 只处理选中的
          if (!this.chart1Selected.includes(id)) return;

          const data = this.chart1MultiData[pillarMap[id]];
          if (data) {
            legendData.push(names[id]);
            series.push({
              name: names[id],
              type: "bar",
              barWidth: 16,
              itemStyle: {
                color: colors[id],
                borderRadius: [2, 2, 0, 0]
              },
              data: this.formatArrayToTwoDecimalPlaces(data.bardata || [])
            });
          }
        });

        this.option1 = {
          toolbox: {
            feature: {
              saveAsImage: { pixelRatio: 2 }
            }
          },
          tooltip: {
            trigger: "axis",
            axisPointer: {
              type: "shadow",
              label: {
                show: true,
                backgroundColor: "#1D91CE"
              }
            }
          },
          // legend: {
          //   data: legendData,
          //   x: "left",
          //   padding: [10, 0, 10, 40]
          // },
          xAxis: {
            type: "category",
            data: xAxisData,
            axisTick: { show: false }
          },
          yAxis: {
            type: "value",
            name: "得分",
            splitLine: { show: false }
          },
          series: series
        };

        this.$nextTick(() => {
          if (this.$refs.chart1 && this.$refs.chart1.chart) {
            this.$refs.chart1.chart.clear();
            this.$refs.chart1.chart.setOption(this.option1);
          }
        });
      } catch (error) {
        console.error("加载图一多选数据失败:", error);
      }
    },
    async loadchart2() {
      if (!this.interfaceGetYearData || this.interfaceGetYearData.length < 1) {
        setTimeout(() => this.loadchart2(), 300);
        return;
      }

      const startYear = this.interfaceGetYearData[0];

      const data = await api.get(
        "/doingBusiness2026Controller/getCountryRankByYear",
        {
          countryId: this.countryid,
          timeId: startYear.value
        }
      );

      if ((data.names.length) > 0 && (data.values.length > 0)) {
        this.option2.series[0].data = data.values;
        this.option2.yAxis[0].data = data.names;
        this.chart2_chart = true
        this.chart2_img = false
      } else {
        this.option2.series[0].data = []
        this.option2.yAxis[0].data = []
        this.chart2_chart = false
        this.chart2_img = true
      }
    },
    async loadchart3() {
      if (!this.interfaceGetYearData || this.interfaceGetYearData.length < 1) {
        setTimeout(() => this.loadchart3(), 300);
        return;
      }

      const startYear = this.interfaceGetYearData[0];
      const res = await api.get(
        "/doingBusiness2026Controller/getCountryScoreByYear",
        {
          countryId: this.countryid,
          timeId: startYear.value,
        }
      );

      if (res && Array.isArray(res) && res.length > 0) {
        this.chartData3 = [{
          date: startYear.name || startYear.value || "",
          IndicatorName: "得分",
          data: res
        }];
      }
    },
    datepicker1change(value) {
      this.flag = 1;
      this.chart4date1 = value;
      if (this.chart4date2 == "") {
        {
          this.$message({
            message: "请选择结束时间",
            type: "warning"
          });
        }
      }
      this.loadchart4Multi();
    },
    datepicker2change(value) {
      this.flag = 1;
      this.chart4date2 = value;
      if (this.chart4date1 == "") {
        {
          this.$message({
            message: "请选择开始日期",
            type: "warning"
          });
        }
      }
      this.loadchart4Multi();
    },
    // 图四：点击切换选中状态（可多选）
    handleClickC4(id) {
      const index = this.chart4Selected.indexOf(id);
      if (index > -1) {
        // 至少保留一个选中
        if (this.chart4Selected.length > 1) {
          this.chart4Selected.splice(index, 1);
        }
      } else {
        this.chart4Selected.push(id);
      }
      this.loadchart4Multi();
    },
    // 图四：加载多选数据
    async loadchart4Multi() {
      try {
        if (!this.chart4date1 || !this.chart4date2) {
          console.warn("图四时间未初始化，跳过加载");
          return;
        }
        if (this.chart4Selected.length === 0) return;
        if (!this.C4ChildrenList || !this.C4ChildrenList.IndicatorId) {
          console.warn("C4ChildrenList 未初始化，跳过加载");
          return;
        }

        // 只加载选中的数据
        const requests = [];
        // 固定颜色配置（最多8个）
        const fixedColors = ['#8DC6F5', '#52c41a', '#F07226', '#722ed1', '#eb2f96', '#faad14', '#13c2c2', '#f5222d'];

        // 构建id到名称的映射
        const nameMap = {};
        if (this.C4ChildrenList.children) {
          this.C4ChildrenList.children.forEach(child => {
            nameMap[child.IndicatorId] = child.Name;
          });
        }
        if (this.C4ChildrenList.IndicatorId != 44) {
          nameMap[this.C4ChildrenList.IndicatorId] = '总分';
        }

        this.chart4Selected.forEach(id => {
          const cacheKey = `id_${id}`;
          if (!this.chart4MultiData[cacheKey]) {
            requests.push(
              api.get("/doingBusiness2026Controller/getSelectiveRankAndScore", {
                countryId: this.countryid,
                indicatorId: id,
                startTid: this.chart4date1,
                endTid: this.chart4date2,
                flag: 1
              }).then(res => {
                this.chart4MultiData[cacheKey] = res.code === 0 ? res.data : null;
              })
            );
          }
        });

        if (requests.length > 0) {
          await Promise.all(requests);
        }

        // 以第一个有数据的为基准获取x轴
        let baseData = null;
        for (const id of this.chart4Selected) {
          const data = this.chart4MultiData[`id_${id}`];
          if (data) {
            baseData = data;
            break;
          }
        }
        const xAxisData = baseData ? (baseData.time || []) : [];

        // 构建固定顺序数组：children 在前，总分在后
        const fixedOrder = [];
        // 先放 children（按原始顺序）
        if (this.C4ChildrenList.children) {
          this.C4ChildrenList.children.forEach(child => {
            fixedOrder.push(child.IndicatorId);
          });
        }
        // 最后放总分
        if (this.C4ChildrenList.IndicatorId != 44) {
          fixedOrder.push(this.C4ChildrenList.IndicatorId);
        }

        // 构建series —— 按固定顺序，只显示选中的
        const series = [];
        const legendData = [];

        fixedOrder.forEach((id, idx) => {
          // 只处理选中的
          if (!this.chart4Selected.includes(id)) return;

          const data = this.chart4MultiData[`id_${id}`];
          if (data) {
            const name = nameMap[id] || `指标${id}`;
            legendData.push(name);
            series.push({
              name: name,
              type: "bar",
              barWidth: 16,
              itemStyle: {
                color: fixedColors[idx % fixedColors.length],
                borderRadius: [2, 2, 0, 0]
              },
              data: this.formatArrayToTwoDecimalPlaces(data.bardata || [])
            });
          }
        });

        this.option4 = {
          toolbox: {
            feature: {
              saveAsImage: { pixelRatio: 2 }
            }
          },
          tooltip: {
            trigger: "axis",
            axisPointer: {
              type: "shadow",
              label: {
                show: true,
                backgroundColor: "#1D91CE"
              }
            }
          },
          // legend: {
          //   data: legendData,
          //   x: "left",
          //   padding: [10, 0, 10, 40]
          // },
          xAxis: {
            type: "category",
            data: xAxisData,
            axisTick: { show: false },
            axisLabel: {
              rotate: 40
            }
          },
          yAxis: {
            type: "value",
            name: "得分",
            splitLine: { show: false }
          },
          series: series
        };

        this.$nextTick(() => {
          if (this.$refs.chart4 && this.$refs.chart4.chart) {
            this.$refs.chart4.chart.clear();
            this.$refs.chart4.chart.setOption(this.option4);
          }
        });
      } catch (error) {
        console.error("加载图四多选数据失败:", error);
      }
    },
    //图5经济体下拉
    async loadchart5country() {
      const { code, data } = await api.get(
        "/doingBusiness2026Controller/getTimesAndCountrys"
      );
      if (code === 0) {
        if (data.countryNames[0].name == "全部经济体")
          data.countryNames.splice(0, 1);
        this.chart5country = data.countryNames;
      }
    },
    selectchart5countrys(value) {
      this.countryBId = value || [];
      this.loadchart5();
    },
    //图5
    async loadchart5() {
      let compareIds = [];
      if (Array.isArray(this.countryBId)) {
        compareIds = this.countryBId.filter(id => id && id !== this.countryid);
      } else if (this.countryBId && this.countryBId !== this.countryid) {
        compareIds = [this.countryBId];
      }

      if (compareIds.length > 5) {
        compareIds = compareIds.slice(0, 5);
        this.countryBId = compareIds;
        this.chart5countrymodel = compareIds;
        this.$message.warning("最多只能选择5个国家进行对比");
      }

      const countryBIdParam = compareIds.length > 0 ? compareIds.join(",") : "";
      const allIds = [this.countryid, ...compareIds];
      const countryIdsParam = allIds.join(",");

      const { code, data, max } = await api.get(
        "/doingBusiness2026Controller/getRadarData2",
        {
          countryIds: countryIdsParam
        }
      );

      if (code === 0) {
        let chart5legend = [];
        let seriesData = [];

        const colors = ["#F07226", "#14A8D6", "#52c41a", "#722ed1", "#eb2f96", "#faad14"];

        for (let indicatornum = 0; indicatornum < 10; indicatornum++) {
          this.option5.radar.indicator[indicatornum].max = max;
        }

        if (data && data.length > 0) {
          const validData = data.filter(item => item.name !== "指标");
          const currentCountryName = validData[0] ? validData[0].name[0] : "";
          if (validData.length > 1 && validData[1].name[0]) {
            const compareNames = validData.slice(1).map(item => item.name[0]).filter(n => n);
            this.chart5title = currentCountryName + "与" + (compareNames.length > 1 ? compareNames[0] + "等经济体" : compareNames[0] + "");
          } else {
            this.chart5title = currentCountryName + "";
          }

          let validIndex = 0;
          data.forEach((item) => {
            if (item.name !== "指标") {
              chart5legend.push(item.name);
              const twoDecimal = this.formatArrayToTwoDecimalPlaces(item.value);
              const color = colors[validIndex % colors.length];
              seriesData.push({
                name: item.name,
                type: "radar",
                symbolSize: 4,
                lineStyle: {
                  normal: {
                    color: color,
                    width: 2
                  }
                },
                itemStyle: {
                  color: color
                },
                data: [{ value: twoDecimal }]
              });
              validIndex++;
            }
          });
        }

        this.option5 = {
          ...this.option5,
          color: colors,
          legend: {
            x: "left",
            y: "bottom",
            orient: "vertical",
            icon: "roundRect",
            padding: [0, 0, 30, 40],
            data: chart5legend
          },
          series: seriesData
        };
      }
    },

    formatArrayToTwoDecimalPlaces(arr) {
      if (!Array.isArray(arr)) return [];
      return arr.map(element => {
        const num = parseFloat(element);
        if (isNaN(num)) {
          return element;
        }
        return num.toFixed(2);
      });
    },
    //营商报告
    async loaddocument() {
      const { code, data } = await api.get(
        "/doingBusiness2026Controller/getPageChannelDocumentsByUId",
        {
          curPage: 1,
          pageSize: 10,
          uid: "800402",
          attr: this.countryname
        }
      );
      if (code === 0) {
        this.docs = data.data;
        this.docs1 = this.docs.slice(0, 5);
        this.docs2 = this.docs.slice(5, 10);
      }
    },
    //icon赋不同样式
    icon1() {
      this.indicatorid = 1;
      $(".icon1").addClass("icon1_on");
      $(".icon1").children().addClass("icon1_on_span");
      this.icon0(1);
    },
    icon2() {
      $(".icon2").addClass("icon2_on");
      $(".icon2").children().addClass("icon2_on_span");
      this.icon0(2);
    },
    icon3() {
      this.indicatorid = 3;
      $(".icon3").addClass("icon3_on");
      $(".icon3").children().addClass("icon3_on_span");
      this.icon0(3);
    },
    icon4() {
      this.indicatorid = 4;
      $(".icon4").addClass("icon4_on");
      $(".icon4").children().addClass("icon4_on_span");
      this.icon0(4);
    },
    icon5() {
      this.indicatorid = 5;
      $(".icon5").addClass("icon5_on");
      $(".icon5").children().addClass("icon5_on_span");
      this.icon0(5);
    },
    icon6() {
      this.indicatorid = 6;
      $(".icon6").addClass("icon6_on");
      $(".icon6").children().addClass("icon6_on_span");
      this.icon0(6);
    },
    icon7() {
      this.indicatorid = 7;
      $(".icon7").addClass("icon7_on");
      $(".icon7").children().addClass("icon7_on_span");
      this.icon0(7);
    },
    icon8() {
      this.indicatorid = 8;
      $(".icon8").addClass("icon8_on");
      $(".icon8").children().addClass("icon8_on_span");
      this.icon0(8);
    },
    icon9() {
      this.indicatorid = 9;
      $(".icon9").addClass("icon9_on");
      $(".icon9").children().addClass("icon9_on_span");
      this.icon0(9);
    },
    icon10() {
      this.indicatorid = 10;
      $(".icon10").addClass("icon10_on");
      $(".icon10").children().addClass("icon10_on_span");
      this.icon0(10);
    },
    icon11() {
      this.indicatorid = 11;
      $(".icon11").addClass("icon11_on");
      $(".icon11").children().addClass("icon11_on_span");
      this.icon0(11);
    },
    //除当时icon，移除其它on样式
    icon0(num) {
      for (let i = 1; i <= 11; i++) {
        if (num != i) {
          $(".icon" + i).removeClass("icon" + i + "_on");
          $(".icon" + i).children().removeClass("icon" + i + "_on_span");
        }
      }
    }
  },
  components: {
    // 修复：组件名统一为短横线形式，HTML中使用 c-chart
    cChart, PillarChart, singleBar
  },
  watch: {
    $route: function () {
      this.init();
    }
  }
};
</script>



<style lang='less' scoped>
.clear {
  clear: both;
}

// 营商头部基本信息
.country {
  padding: 25px;
}

.country img {
  float: left;
}

.country h2 {
  float: left;
  font-size: 18x;
  line-height: 25px;
  padding-left: 10px;
}

.characteristics ul li {
  float: left;
  padding-left: 5px;
  padding-right: 20px;
  padding-top: 10px;
}

.characteristics ul li span {
  font-weight: bold;
}

.mapbox {
  padding: 5px 10px;
  box-sizing: border-box;

  .ysbg {
    ul {
      width: 50%;
      padding: 25px;

      li {
        line-height: 35px;

        a {
          color: #333;
          width: 80%;
          text-overflow: ellipsis;
          white-space: nowrap;
          overflow: hidden;
          text-align: left;

          .icon_lx {
            padding-right: 5px;
          }
        }

        span {
          color: #666;
        }
      }
    }
  }
}

.mt_h {
  margin-top: 6px;
}

.w33 {
  width: 33.33%;
  padding: 0 5px;
  position: relative;
}



.col-lg-6 {
  float: left;
  border-left: 1px solid #d7dfe3;
  border-top: 1px solid #d7dfe3;
  padding: 20px 20px 30px 20px;
}

.col-lg-6 h2 {
  font-size: 15px;
  font-weight: bold;
  /*! line-height: 34px; */
  margin-top: 17px;
  margin-left: 20px;
}

.review {
  border: 1px solid transparent;
  border-radius: 5px;
  color: #777;
  display: flex;
  font-size: 12px;
  align-items: center;
  margin: 0px 10px;
  width: 57.5%;
  margin-top: 9px;
}

.progress {
  background-color: rgba(100, 100, 100, 0.2);
  border-radius: 100px;
  position: relative;
  margin: 0 5px;
  height: 20px;
  width: 90%;
}

.progress-done1 {
  background: linear-gradient(to left, rgb(103, 194, 58), rgb(166, 213, 83));
  border-radius: 100px;
  height: 20px;
  transition: width 1s ease 0.3s;
}

.progress-done2 {
  background: linear-gradient(to left, rgb(242, 97, 90), rgb(255, 148, 114));
  border-radius: 100px;
  height: 20px;
  transition: width 1s ease 0.3s;
}

.percent {
  color: #333;
  white-space: nowrap;
  z-index: 999;
}

.percent1 {
  position: absolute;
  left: 0px;
  display: inline-block;
  color: #fff;
  font-size: 14px;
  line-height: 20px;
}

// 柱状图
.card_title {
  position: relative;
  background: url(../../../assets/imgs/titlebj.png) repeat-x top;
  height: 45px;
  line-height: 45px;
  border-bottom: 1px solid #d7dfe3;
  border-left: 1px solid #d7dfe3;
  margin-left: -1px;
}

.card_title .more,
.card_title h1,
.card_title span {
  text-align: center;
  line-height: 45px;
  font-weight: 600;
  font-size: 0.95vw;
  font-size: 15px;
}

.card_title .more {
  position: absolute;
  top: 0px;
  right: 30px;
  color: #202223;
  // margin-left: 100px;
}

.card_title .more:hover {
  color: #1260af;
}

.w50 {
  width: 50%;
  padding: 0 5px;
  position: relative;
}

.menu_box_ul {
  background: #f4f7fa;
  border: 1px solid #d4dfea;
  border-radius: 20px;
  width: 100%;
  // padding: 15px;
  padding-left: 0;
  margin: 20px 0px 0px 12px;
  position: relative;
}

.menu_box_ul li {
  line-height: 35px;
  padding-right: 5px;
}

.menu_box_ul li a {
  display: block;
  height: 34px;
  font-size: 13px;
  line-height: 34px;
  color: #30363c;
  text-align: left;
}

.txbox {
  width: 74%;
}

//可选指标柱状图
.c-datepicker-date-editor {
  -webkit-appearance: none;
  background-color: #fff;
  background-image: none;
  border-radius: 4px;
  border: 1px solid#dcdfe6;
  box-sizing: border-box;
  color: #333;
  display: inline-block;
  font-size: inherit;
  height: 34px;
  line-height: 34px;
  outline: none;
  padding: 0 15px;
  white-space: nowrap;
  margin-top: 15px;
  margin-left: 20px;
  margin-right: 20px;
}

.c-datepicker-range__icon {
  display: inline-block;
  text-align: center;
}

/deep/.elinputiconimg {
  background: url(../../../assets/imgs/time.png) no-repeat;
  height: 16px;
  display: inline-block;
  width: 16px;
  margin-top: 8px;
}

.c-datepicker-data-input.only-date {
  width: 86px;
}

.c-datepicker-data-input {
  border: none;
  outline: none;
  display: inline-block;
  height: 100%;
  margin: 0;
  padding: 0;
  text-align: center;
  font-size: 14px;
  color: #333;
  line-height: 1;
  vertical-align: top;
  background-color: #fff;
}

.c-datepicker-range-separator {
  padding: 0 3px;
  display: inline-block;
  text-align: center;
}

.datepickerwidth {
  width: 250px;
  margin-top: 15px;
}

/deep/.el-input__inner_date {
  width: 110px;
  margin-top: 10px;

  input {
    height: 34px;
    font-size: 12px;
  }
}

.icon1 {
  background: url(../../../assets/imgs/icon1_ys.png) no-repeat 10px 7px;
  height: 24px;
  padding-left: 32px;
}

.icon1:hover {
  background: url(../../../assets/imgs/icon1_h.png) no-repeat 10px 7px;
  height: 34px;
  padding-left: 32px;
  cursor: pointer;
}

.icon1_on {
  background: url(../../../assets/imgs/icon1_h.png) no-repeat 10px 7px;
  height: 34px;
  padding-left: 32px;
  cursor: pointer;
}

.icon1:hover span {
  color: #f6231b;
  font-weight: 700;
}

.icon1_on_span {
  color: #f6231b;
  font-weight: 700;
}

.icon2 {
  background: url(../../../assets/imgs/icon2_ys.png) no-repeat 10px 7px;
  height: 24px;
  padding-left: 32px;
}

.icon2:hover {
  background: url(../../../assets/imgs/icon2_h.png) no-repeat 10px 7px;
  height: 34px;
  padding-left: 32px;
  cursor: pointer;
}

.icon2_on {
  background: url(../../../assets/imgs/icon2_h.png) no-repeat 10px 7px;
  height: 34px;
  padding-left: 32px;
  cursor: pointer;
}

.icon2:hover span {
  color: #3bd5a1;
  font-weight: 700;
}

.icon2_on_span {
  color: #3bd5a1;
  font-weight: 700;
}


.icon3 {
  background: url(../../../assets/imgs/icon3_ys.png) no-repeat 10px 7px;
  height: 24px;
  padding-left: 32px;
}

.icon3:hover {
  background: url(../../../assets/imgs/icon3_h.png) no-repeat 10px 7px;
  height: 34px;
  padding-left: 32px;
  cursor: pointer;
}

.icon3_on {
  background: url(../../../assets/imgs/icon3_h.png) no-repeat 10px 7px;
  height: 34px;
  padding-left: 32px;
  cursor: pointer;
}

.icon3:hover span {
  color: #9954ac;
  font-weight: 700;
}

.icon3_on_span {
  color: #9954ac;
  font-weight: 700;
}

.icon4 {
  background: url(../../../assets/imgs/icon4_ys.png) no-repeat 10px 7px;
  height: 24px;
  padding-left: 32px;
}

.icon4:hover {
  background: url(../../../assets/imgs/icon4_h.png) no-repeat 10px 7px;
  height: 34px;
  padding-left: 32px;
  cursor: pointer;
}

.icon4_on {
  background: url(../../../assets/imgs/icon4_h.png) no-repeat 10px 7px;
  height: 34px;
  padding-left: 32px;
  cursor: pointer;
}

.icon4:hover span {
  color: #2bcaf4;
  font-weight: 700;
}

.icon4_on_span {
  color: #2bcaf4;
  font-weight: 700;
}

.icon5 {
  background: url(../../../assets/imgs/icon5_ys.png) no-repeat 10px 7px;
  height: 24px;
  padding-left: 32px;
}

.icon5:hover {
  background: url(../../../assets/imgs/icon5_h.png) no-repeat 10px 7px;
  height: 34px;
  padding-left: 32px;
  cursor: pointer;
}

.icon5_on {
  background: url(../../../assets/imgs/icon5_h.png) no-repeat 10px 7px;
  height: 34px;
  padding-left: 32px;
  cursor: pointer;
}

.icon5:hover span {
  color: #fd924b;
  font-weight: 700;
}

.icon5_on_span {
  color: #fd924b;
  font-weight: 700;
}

.icon6 {
  background: url(../../../assets/imgs/icon6_ys.png) no-repeat 10px 7px;
  height: 24px;
  padding-left: 32px;
}

.icon6:hover {
  background: url(../../../assets/imgs/icon6_h.png) no-repeat 10px 7px;
  height: 34px;
  padding-left: 32px;
  cursor: pointer;
}

.icon6_on {
  background: url(../../../assets/imgs/icon6_h.png) no-repeat 10px 7px;
  height: 34px;
  padding-left: 32px;
  cursor: pointer;
}

.icon6:hover span {
  color: #6a75f5;
  font-weight: 700;
}

.icon6_on_span {
  color: #6a75f5;
  font-weight: 700;
}

.icon7 {
  background: url(../../../assets/imgs/icon7_ys.png) no-repeat 10px 7px;
  height: 24px;
  padding-left: 32px;
}

.icon7:hover {
  background: url(../../../assets/imgs/icon7_h.png) no-repeat 10px 7px;
  height: 34px;
  padding-left: 32px;
  cursor: pointer;
}

.icon7_on {
  background: url(../../../assets/imgs/icon7_h.png) no-repeat 10px 7px;
  height: 34px;
  padding-left: 32px;
  cursor: pointer;
}

.icon7:hover span {
  color: #5cd46c;
  font-weight: 700;
}

.icon7_on_span {
  color: #5cd46c;
  font-weight: 700;
}

.icon8 {
  background: url(../../../assets/imgs/icon8_ys.png) no-repeat 10px 7px;
  height: 24px;
  padding-left: 32px;
}

.icon8:hover {
  background: url(../../../assets/imgs/icon8_h.png) no-repeat 10px 7px;
  height: 34px;
  padding-left: 32px;
  cursor: pointer;
}

.icon8_on {
  background: url(../../../assets/imgs/icon8_h.png) no-repeat 10px 7px;
  height: 34px;
  padding-left: 32px;
  cursor: pointer;
}

.icon8:hover span {
  color: #c79706;
  font-weight: 700;
}

.icon8_on_span {
  color: #c79706;
  font-weight: 700;
}

.icon9 {
  background: url(../../../assets/imgs/icon9_ys.png) no-repeat 10px 7px;
  height: 24px;
  padding-left: 32px;
}

.icon9:hover {
  background: url(../../../assets/imgs/icon9_h.png) no-repeat 10px 7px;
  height: 34px;
  padding-left: 32px;
  cursor: pointer;
}

.icon9_on {
  background: url(../../../assets/imgs/icon9_h.png) no-repeat 10px 7px;
  height: 34px;
  padding-left: 32px;
  cursor: pointer;

}

.icon9:hover span {
  color: #71b5fe;
  font-weight: 700;
}

.icon9_on_span {
  color: #71b5fe;
  font-weight: 700;
}

.icon10 {
  background: url(../../../assets/imgs/icon10_ys.png) no-repeat 10px 7px;
  height: 24px;
  padding-left: 32px;
}

.icon10:hover {
  background: url(../../../assets/imgs/icon10_h.png) no-repeat 10px 7px;
  height: 34px;
  padding-left: 32px;
  cursor: pointer;
}

.icon10_on {
  background: url(../../../assets/imgs/icon10_h.png) no-repeat 10px 7px;
  height: 34px;
  padding-left: 32px;
  cursor: pointer;
}

.icon10:hover span {
  color: #fd91a3;
  font-weight: 700;
}

.icon10_on_span {
  color: #fd91a3;
  font-weight: 700;
}

.icon11 {
  background: url(../../../assets/imgs/icon11_ys.png) no-repeat 10px 7px;
  height: 24px;
  padding-left: 32px;
}

.icon11:hover {
  background: url(../../../assets/imgs/icon11_h.png) no-repeat 11px 7px;
  height: 34px;
  padding-left: 32px;
  cursor: pointer;
}

.icon11_on {
  background: url(../../../assets/imgs/icon11_h.png) no-repeat 11px 7px;
  height: 34px;
  padding-left: 32px;
  cursor: pointer;
}

.icon11:hover span {
  color: #2bcaf4;
  font-weight: 700;
}

.icon11_on_span {
  color: #2bcaf4;
  font-weight: 700;
}

//雷达图
.k-dropdown-wrap {
  width: 210px;
}

.k-state-default {
  position: absolute;
  height: 40px;
  line-height: 38px;
  border: 0px;
  border-radius: 0px;
  text-align: left;
  background-color: #1583cc;
  color: #ffffff;
  -webkit-box-shadow: none;
  box-shadow: none;
  float: left;
  background-image: none;
  margin-top: 7px;
  margin-left: 10px;
}

.k-input {
  font-size: 14px;
  line-height: 24px;
  color: #fff;
  padding-left: 20px;
  position: relative;
  top: 6px;
}

.k-select {
  width: 2.6em;
}

.k-select {
  position: absolute;
  top: 11px;
  right: 0;
  display: inline-block;
}

.k-icon {
  position: relative;
  display: inline-block;
  overflow: hidden;
  width: 1em;
  height: 1em;
  text-align: center;
  vertical-align: middle;
  background: url(../../../assets/imgs/drop-down1.png) no-repeat center;
  font: 16px/1 WebComponentsIcons;
  font-variant-caps: normal;
  font-weight: normal;
  font-family: WebComponentsIcons;
  font-variant-alternates: normal;
  font-variant-east-asian: normal;
  font-variant-ligatures: normal;
  font-variant-numeric: normal;
  font-variant-position: normal;
  speak: none;
  font-variant: normal;
  text-transform: none;
  text-indent: 0;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: inherit;
}

.ld_jjt {
  background: #f4f7fa !important;
  border: 1px solid#d4dfea;
  border-radius: 100px;
}

.black {
  color: #30363c !important;
}

.k-icon2 {
  position: relative;
  display: inline-block;
  overflow: hidden;
  width: 1em;
  height: 1em;
  text-align: center;
  vertical-align: middle;
  background: url(../../../assets/imgs/drop-down2.png) no-repeat center;
  font: 16px/1 WebComponentsIcons;
  font-variant-caps: normal;
  font-weight: normal;
  font-family: WebComponentsIcons;
  font-variant-alternates: normal;
  font-variant-east-asian: normal;
  font-variant-ligatures: normal;
  font-variant-numeric: normal;
  font-variant-position: normal;
  speak: none;
  font-variant: normal;
  text-transform: none;
  text-indent: 0;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: inherit;
}

/deep/.chart5elselect {
  margin: 10px 0 0 10px;
  width: 400px;
  display: flex;
  align-items: center;
  gap: 8px;

  .current-country-tag {
    display: inline-flex;
    align-items: center;
    background: #e6f7ff;
    border: 1px solid #91d5ff;
    border-radius: 4px;
    padding: 0 8px;
    height: 32px;
    white-space: nowrap;
    flex-shrink: 0;

    .tag-label {
      color: #1890ff;
      font-size: 12px;
      margin-right: 4px;
    }

    .tag-name {
      color: #096dd9;
      font-size: 13px;
      font-weight: 600;
    }
  }

  .compare-select {
    flex: 1;
  }

  input {
    background: #f4f7fa !important;
    border: 1px solid#d4dfea;
    border-radius: 100px;
  }

  .el-select__tags {
    flex-wrap: wrap;
  }
}

//营商报告
.ysbg ul {
  width: 50%;
  float: left;
  padding: 25px;
}

.ysbg ul li {
  line-height: 35px;
}

.ysbg ul li span {
  color: #666;
}

.icon_lx {
  padding-right: 5px;
}

.C1-style {
  display: inline-block;
  padding: 4px 8px;
  margin: 14px auto;
  border: 1px solid #ddd;
  border-radius: 10px;
  font-size: 12px;
  cursor: pointer;

  &:not(:last-child) {
    margin-right: 8px;
  }

  &:hover {
    background: #1583cc;
    color: #fff;
    border: 1px solid #1588d4
  }

}

.NC-active {
  background: #1583cc !important;
  color: #fff !important;
  border: 1px solid #1588d4 !important;
}

::v-deep .el-select__tags {
  padding: 0 10px;
}
</style>